module.exports = __webpack_public_path__ + "static/img/3_1_8.0336eb84.jpg";